import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { CheckoutFragmentFragment } from "../generated/api"
import { shopifySdk } from "../services/graphqlClient"
import uoStorage, { LocalStores } from "../services/uoStorage"
import { RootState } from "./store"

export const refetch = createAsyncThunk(
  "checkout/refetch",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState() as RootState
    const id = state?.checkout?.id
    if (!id) return
    const result = ((
      await shopifySdk.GetCheckoutById({
        id,
      })
    ).node as unknown) as CheckoutFragmentFragment
    thunkAPI.dispatch(setCheckout(result))
  }
)

export const createCheckout = createAsyncThunk(
  "checkout/create",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState() as RootState
    let checkoutId = state.checkout?.id
    if (!checkoutId) {
      const checkout = (
        await shopifySdk.CreateCheckout({
          input: {},
        })
      ).checkoutCreate.checkout
      thunkAPI.dispatch(setCheckout(checkout))
    }
  }
)

export const addItem = createAsyncThunk(
  "checkout/addItem",
  async (item: { variantId: string; quantity: number }, thunkAPI) => {
    const state = thunkAPI.getState() as RootState
    let checkoutId = state.checkout?.id
    if (!checkoutId) {
      await thunkAPI.dispatch(createCheckout())
    }
    const checkout = (
      await shopifySdk.AddLineItemToCheckout({
        checkoutId: (thunkAPI.getState() as RootState).checkout.id,
        lineItems: [item],
      })
    ).checkoutLineItemsAdd.checkout
    thunkAPI.dispatch(setCheckout(checkout))
  }
)

export const removeItem = createAsyncThunk(
  "checkout/removeItem",
  async (item: string, thunkAPI) => {
    const state = thunkAPI.getState() as RootState
    let checkoutId = state.checkout?.id
    const checkout = (
      await shopifySdk.CheckoutLineItemsRemove({
        checkoutId,
        lineItemIds: [item],
      })
    ).checkoutLineItemsRemove.checkout
    thunkAPI.dispatch(setCheckout(checkout))
  }
)

const checkoutSlice = createSlice({
  name: "checkout",
  initialState: {
    id: uoStorage.getItem(LocalStores.checkout) || null,
  } as CheckoutFragmentFragment | null,
  reducers: {
    setCheckout(state, payload: PayloadAction<CheckoutFragmentFragment>) {
      state = payload.payload
      return state
    },
  },
})

export const { setCheckout } = checkoutSlice.actions

export default checkoutSlice.reducer
